let execBeforeUnload = false;

export function processing(options: any = undefined): void {
  const targetScreen = document.getElementsByClassName("cms-process-screen");
  const targetLoader = document.getElementsByClassName("cms-process-loader");

  if (targetScreen[0]) {
    targetScreen[0].parentNode?.removeChild(targetScreen[0]);
  }
  if (targetLoader[0]) {
    targetLoader[0].parentNode?.removeChild(targetLoader[0]);
  }

  const screen = document.createElement("div");
  screen.setAttribute("class", "cms-process-screen");
  screen.style.cssText =
    "top: 0;" +
    "left: 0;" +
    "width: 100%;" +
    "height: 100%;" +
    "position: fixed;" +
    "padding: 20px 30px;" +
    "background-color: rgba(0, 0, 0, 0.5);" +
    "z-index: 1000000000;";

  if (options?.close) {
    screen.onclick = function () {
      processend(options);
    };
  }
  document.body.appendChild(screen);

  if (options?.loading) {
    const container = document.createElement("div");

    container.setAttribute("class", "cms-process-loader");
    container.style.cssText =
      "position: fixed;" +
      "padding: 20px 30px;" +
      "background-color: rgba(0, 0, 0, 0.5);" +
      "border-radius: 10px;" +
      "z-index: 1101;" +
      "text-align: center;";

    const image = new Image();
    image.src = "/common/img/ajax-loader.gif";
    container.append(image);

    document.body.appendChild(container);

    const appendedContainer =
      document.getElementsByClassName("cms-process-loader");
    if (appendedContainer[0]) {
      const winHeight = window.innerHeight;
      const winWidth = window.innerWidth;

      const width = appendedContainer[0].clientWidth;
      const height = appendedContainer[0].clientHeight;

      const top = (winHeight - height) / 2;
      const left = (winWidth - width) / 2;
      const attributes = appendedContainer[0].attributes;
      let style: string | null = "";
      for (let i = 0; i < attributes.length; i++) {
        if (attributes[i].name == "style") {
          style = attributes[i].nodeValue;
          break;
        }
      }
      if (style) {
        style = style + "top:" + top + "px;left:" + left + "px;";
      } else {
        style = "top:" + top + "px;left:" + left + "px;";
      }
      appendedContainer[0].setAttribute("style", style);
    }
  }

  if (options?.loader || options?.message || options?.contents) {
    const container = document.createElement("div");

    container.setAttribute("class", "cms-process-loader");

    if (options?.loader) {
      const image = new Image();
      image.src = "/common/img/loader_circle.gif";
      container.append(image);
    }

    if (options?.message) {
      const message = document.createElement("div");
      message.innerHTML = options.message;
      message.style.cssText = "margin: 20px 0 0 0;" + "color: #000;";
      container.append(message);
    }

    if (options?.contents) {
      container.append(options.contents);
    }

    container.style.cssText =
      "position: fixed;" +
      "padding: 20px 30px;" +
      "background-color: #fff;" +
      "border-radius: 10px;" +
      "z-index: 1101;" +
      "text-align: center;";
    document.body.appendChild(container);

    const appendedContainer =
      document.getElementsByClassName("cms-process-loader");
    if (appendedContainer[0]) {
      const winHeight = window.innerHeight;
      const winWidth = window.innerWidth;

      const width = appendedContainer[0].clientWidth;
      const height = appendedContainer[0].clientHeight;

      const top = (winHeight - height) / 2;
      const left = (winWidth - width) / 2;
      const attributes = appendedContainer[0].attributes;
      let style: string | null = "";
      for (let i = 0; i < attributes.length; i++) {
        if (attributes[i].name == "style") {
          style = attributes[i].nodeValue;
          break;
        }
      }
      if (style) {
        style = style + "top:" + top + "px;left:" + left + "px;";
      } else {
        style = "top:" + top + "px;left:" + left + "px;";
      }
      appendedContainer[0].setAttribute("style", style);
    }
  }
}

export function processend(options: any = undefined): void {
  const targetScreen = document.getElementsByClassName("cms-process-screen");
  const targetLoader = document.getElementsByClassName("cms-process-loader");

  if (targetScreen[0]) {
    targetScreen[0].parentNode?.removeChild(targetScreen[0]);
  }
  if (targetLoader[0]) {
    targetLoader[0].parentNode?.removeChild(targetLoader[0]);
  }
  if (options?.complete) {
    options.complete();
  }
}

export function screening(): void {
  const targetScreen = document.getElementsByClassName("cms-process-screen");
  if (targetScreen[0]) {
    targetScreen[0].parentNode?.removeChild(targetScreen[0]);
  }

  const screen = document.createElement("div");
  screen.setAttribute("class", "cms-process-screen");
  screen.style.cssText =
    "top: 0;" +
    "left: 0;" +
    "width: 100%;" +
    "height: 100%;" +
    "position: fixed;" +
    "padding: 20px 30px;" +
    "background-color: rgba(0, 0, 0, 0.2);" +
    "z-index: 1100;";
  document.body.appendChild(screen);
}

export function setExecBeforeUnload(val: boolean): void {
  execBeforeUnload = val;
}

export function getExecBeforeUnload(): boolean {
  return execBeforeUnload;
}

export function changeBeforeUnload(e: Event): void {
  execBeforeUnload = false;
  setTimeout(function () {
    execBeforeUnload = true;
  }, 1000);
}
